// API utility functions
export const apiCall = async (endpoint, options = {}) => {
  const baseURL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
  
  const config = {
    credentials: 'include',  // Send HTTP-only cookies automatically
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
    ...options,
  };

  // Handle data serialization for POST/PUT requests
  if (options.data) {
    config.body = JSON.stringify(options.data);
    delete config.data; // Remove data from options to avoid conflicts
  }

  const response = await fetch(`${baseURL}${endpoint}`, config);
  
  if (!response.ok) {
    let error;
    try {
      error = await response.json();
    } catch (e) {
      error = { detail: `HTTP ${response.status}: ${response.statusText}` };
    }
    const errorObj = new Error(error.detail || 'API call failed');
    errorObj.response = { data: error, status: response.status };
    throw errorObj;
  }
  
  return response.json();
};